/**
 * Apply event listener to run rowCreated workflow
 * @param {Object} workflow - rowAdded workflow
 * @param {Object} eventBus - eventBus instance
 */
export default function(workflow, eventBus) {
  if (!workflow.sourceGrid)
    throw new Error('[simpleWorkflow] - missing "sourceGrid" property')

  eventBus.$on(
    `simpleWorkflow-rowCreated-${workflow.sourceGrid}`,
    async rowData => {
      const actions = workflow.actions

      if (!actions) return

      for (let idx in actions) {
        const action = actions[idx]

        switch (action.type) {
          case 'addRowTo':
            await addRowTo(action, rowData)
            break
          case 'updateCreatedRow':
            updateCreatedRow(workflow.sourceGrid, action, rowData)
            break
        }
      }
    }
  )
}

async function addRowTo(action, rowData) {
  let row = rowData;
  const addedRowKey = await $dgAddRow(action.gridId, { _created: true })
  const newRow = Object.assign({}, $dataGrid(action.gridId)[addedRowKey])

  if (action.writeMethods && action.writeMethods.length) {
    for (let writeMethod of action.writeMethods) {
      switch (writeMethod.type) {
        case 'createdRow':
          newRow[writeMethod.targetCell] = rowData[writeMethod.sourceCell]
          break
        case 'expression':
          try {
            const value = eval(writeMethod.expression)

            newRow[writeMethod.targetCell] = value
          } catch (err) {
            console.error(err)
          }
          break
      }
    }
  }

  $dgSetRow(action.gridId, addedRowKey, newRow)
}

function updateCreatedRow(sourceGrid, action, rowData) {
  let row = rowData;
  const newRow = $dataGrid(sourceGrid)[rowData.rowKey]

  if (action.writeMethods && action.writeMethods.length) {
    for (let writeMethod of action.writeMethods) {
      try {
        const value = eval(writeMethod.expression)

        newRow[writeMethod.targetCell] = value
      } catch (err) {
        console.error(err)
      }
    }
  }

  $dgSetRow(sourceGrid, rowData.rowKey, newRow)
}
